<template>
  <default>
    <div v-if="customer" class="mx-auto p-6 space-y-6 dark:bg-gray-900 min-h-screen">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Zákazník č. {{ customer.id }}</h1>

      <!-- Základní údaje -->
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
        <p class="text-gray-800 dark:text-gray-200"><strong>Jméno:</strong> {{ customer.name }}</p>
        <p v-if="customer.email" class="text-gray-800 dark:text-gray-200"><strong>Email:</strong> {{ customer.email }}</p>
        <p v-if="customer.phone" class="text-gray-800 dark:text-gray-200"><strong>Telefon:</strong> {{ customer.phone }}</p>
      </div>

      <!-- Adresy -->
      <div v-if="customer.addresses" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div v-if="customer.addresses.billing" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Fakturační adresa</h2>
          <AddressBlock :address="customer.addresses.billing" />
        </div>
        <div v-if="customer.addresses.shipping" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Doručovací adresa</h2>
          <AddressBlock :address="customer.addresses.shipping" />
        </div>
      </div>

      <!-- Custom pole -->
      <div v-if="customer.custom?.length" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Vlastní data</h2>
        <RecursiveJson :data="customer.custom" />
      </div>

      <LogsTable :entity-id="customer.id" class="mt-4"/>

    </div>
    <div v-else class="mx-auto p-6 space-y-6 dark:bg-gray-900 min-h-screen animate-pulse">
      <div class="h-6 w-48 bg-gray-300 dark:bg-gray-700 rounded"></div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-3">
        <div class="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-4 w-1/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-4 w-1/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
          <div class="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
          <div class="h-3 w-3/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div class="h-3 w-2/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 space-y-2">
          <div class="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
          <div class="h-3 w-3/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div class="h-3 w-2/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div class="h-4 w-1/3 bg-gray-300 dark:bg-gray-700 rounded mb-3"></div>
        <div class="space-y-2">
          <div class="h-3 w-full bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div class="h-3 w-5/6 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div class="h-3 w-4/6 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </div>

  </default>
</template>
<script lang="ts">

import Default from "@/layouts/admin/default.vue";
import {useAppStore} from "@/stores/appStore";
import AddressBlock from "@/components/AddressBlock.vue";
import RecursiveJson from "@/components/RecursiveJson.vue";
import LogsTable from "@/components/logsTable/logsTable.vue";

export default {
  name: "CustomerDetailView",
  components: {LogsTable, RecursiveJson, AddressBlock, Default},
  data() {
    return {
      customer: null,
      customerId: this.$route.params.customerId,
      appStore: useAppStore(),
      loading: true,
      error: false
    }
  },
  methods:{
    findCustomer(){
      this.$customersApi.findCustomer(
        this.appStore.selectedProject.spaceId,
        this.appStore.selectedProject._id,
        this.customerId
      ).then(response => {
        this.customer = response.data;
      }).catch(error => {
        console.error("Error fetching customer:", error);
        this.error = true;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.findCustomer();
  }
}
</script>